// extracted by mini-css-extract-plugin
export var indeterminate = "_4v-5";
export var md = "_4v-4";
export var semantic = "_4v-6";
export var sm = "_4v-3";
export var text = "_4v-7";
export var toggleInput = "_4v-0";
export var toggleSwitch = "_4v-1";
export var xs = "_4v-2";